export const SET_CURRENT_ORGANIZATION =
  "organizations/SET_CURRENT_ORGANIZATION";

export const FETCH_ORGANIZATIONS_SUCCESS =
  "organizations/FETCH_ORGANIZATIONS_SUCCESS";
